export default __webpack_public_path__ + "static/media/lon.1efc317e.svg";